import React, { useState } from 'react';
import { Button } from '@chakra-ui/react';
import { useMsal } from '@azure/msal-react';

import { loginWithMicrosoft } from '@/api/authApi/authApi';
import { useAuth } from '@/context/AuthContext';
import { microsoftLoginRequest } from '@/config/msal';

const MicrosoftIcon = () => (
    <svg viewBox="0 0 23 23" width="16" height="16" style={{ marginRight: 8 }}>
        <path fill="#f35325" d="M1 1h10v10H1z" />
        <path fill="#81bc06" d="M12 1h10v10H12z" />
        <path fill="#05a6f0" d="M1 12h10v10H1z" />
        <path fill="#ffba08" d="M12 12h10v10H12z" />
    </svg>
);

type MicrosoftSignInButtonProps = {
    onAuthError: (error: any) => void;
    onSigningIn?: () => void;
};

export const MicrosoftSignInButton = ({ onAuthError, onSigningIn }: MicrosoftSignInButtonProps) => {
    const { handleSsoLogin } = useAuth();
    const { instance } = useMsal();
    const [isLoading, setIsLoading] = useState(false);

    const handleMicrosoftSignIn = async () => {
        setIsLoading(true);

        try {
            const result = await instance.loginPopup(microsoftLoginRequest);

            if (!result.idToken) {
                onAuthError({ message: 'Microsoft sign in failed. Please try again.' });
                return;
            }

            onSigningIn?.();
            const response = await loginWithMicrosoft(result.idToken);
            await handleSsoLogin(response.token);
        } catch (err: any) {
            if (err?.errorCode === 'user_cancelled') {
                return;
            }

            onAuthError(err);
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <Button
            w="full"
            h="40px"
            variant="outline"
            borderColor="gray.300"
            fontWeight={500}
            onClick={handleMicrosoftSignIn}
            isLoading={isLoading}
            leftIcon={<MicrosoftIcon />}
        >
            Sign in with Microsoft
        </Button>
    );
};
